import { useState, useEffect } from 'react';

/**
 * Initial value is set to null so client-side and server-side
 * have the same value. After that, it sends updated value to the
 * component using it.
 */
function useLocalStorage(key, initial) {
  // Start with initial value
  const [value, setValue] = useState(null);

  // After page loads, populate from localStorage
  useEffect(() => {
    try {
      const storedValue = window.localStorage.getItem(key);
      setValue(storedValue ? JSON.parse(storedValue) : initial);
    } catch (e) {
      // Most likely due to security or quota exceeded errors, safe to ignore
      setValue(initial);
    }
  }, [key]);

  return [
    value,
    newValue => {
      setValue(newValue);
      try {
        window.localStorage.setItem(key, JSON.stringify(newValue));
      } catch (e) {
        // Most likely due to security or quota exceeded errors, safe to ignore
      }
    },
  ];
}

export default useLocalStorage;
